<!-- @file 等分红包组件 -->
<template>
  <div class="plv-ia-rpr-send__content--send-equal">
    <div
      v-for="(aitem, aindex) in rprList"
      :key="aindex"
      class="plv-ia-rpr-send__content--send-equal__item"
    >
      <cell
        v-model="rprList[aindex].account"
        class="plv-ia-rpr-send__content--send-equal__account"
        :title="langData.singleTitle"
        :special-title="t('plvIA.redpacketRain.deng')"
        :placeholder="t('plvIA.redpacketRain.pleaseEntryMoney')"
        input-type="number"
        is-positive
        :is-round="curPayType === payTypes.point"
        :unit="langData.singleUnit"
        @change="handleAccountChange(aindex)"
        @mouseenter="handleQuickShow(aindex, true)"
        @mouseleave="handleQuickShow(aindex, false)"
      >
        <template slot="input">
          <transition name="plv-ia-rpr-send-zoom-in-bottom">
            <ul
              v-show="aitem.visible"
              class="plv-ia-rpr-send__content--send-equal__quick"
            >
              <li
                v-for="(item, index) in defaultAccounts"
                :key="`${aindex}-${index}`"
                class="plv-ia-rpr-send__content--send-equal__quick__item"
                @click="setQuickMoney(item.value, aindex)"
              >
                {{ item.label }}
              </li>
            </ul>
          </transition>
        </template>
      </cell>

      <cell
        v-model="rprList[aindex].total"
        class="plv-ia-rpr-send__content--send-equal__total"
        :title="t('plvIA.redpacketRain.quantity')"
        :unit="t('plvIA.redpacketRain.ge')"
        :is-round="true"
        :placeholder="t('plvIA.redpacketRain.plesseEntry')"
        @change="handleTotalChange(aindex)"
      />

      <div class="plv-ia-rpr-send__content--send-equal__btns">
        <img
          v-if="rprList.length !== 1"
          class="plv-ia-rpr-send__content--send-equal__btns__item"
          src="../images/icon-del.png"
          @click="delItems(aindex)"
        />
        <img
          v-if="rprList.length !== 3 && aindex === rprList.length - 1"
          class="plv-ia-rpr-send__content--send-equal__btns__item"
          src="../images/icon-add.png"
          @click="addItems"
        />
      </div>
    </div>
  </div>
</template>

<script>
import redpacketBaseData from '../mixins/redpacket-base-data';
import Cell from './cell';
import { EQUAL_SIGNLE_MAX_ACCOUNT, EQUAL_SIGNLE_MAX_COUNT } from '../config';
import Locale from '@/mixins/locale';

export default {
  components: {
    Cell
  },
  mixins: [Locale, redpacketBaseData],

  props: {
    curPayType: {
      type: String,
    },
    defaultAccounts: {
      type: Array,
      default: () => {
        return [];
      }
    },
    /** 等分红包单个金额上限 */
    singleMaxAmount: {
      type: Number,
      default: EQUAL_SIGNLE_MAX_ACCOUNT,
    },
    /** 等分红包单个数量上限 */
    singleMaxCount: {
      type: Number,
      default: EQUAL_SIGNLE_MAX_COUNT,
    },
    pointUnit: {
      type: String,
      default: '积分'
    },
  },
  data() {
    return {
      rprList: [{ account: '', total: '', visible: false }]
    };
  },

  computed: {
    maxAmount() {
      return typeof this.singleMaxAmount === 'number' && this.singleMaxAmount > 0 ? this.singleMaxAmount : EQUAL_SIGNLE_MAX_ACCOUNT;
    },
    maxCount() {
      return typeof this.singleMaxCount === 'number' && this.singleMaxCount > 0 ? this.singleMaxCount : EQUAL_SIGNLE_MAX_COUNT;
    },
    langData() {
      const data = {
        singleTitle: '',
        singleUnit: '',
      };

      switch (this.curPayType) {
        case this.payTypes.cash:
          data.singleTitle = this.t('plvIA.redpacketRain.singlePrice');
          data.singleUnit = this.t('plvIA.redpacketRain.cny');
          break;
        case this.payTypes.point:
          data.singleTitle = this.t('plvIA.redpacketRain.singlePoint', { unit: this.pointUnit });
          data.singleUnit = this.t('plvIA.redpacketRain.ge');
          break;
      }

      return data;
    },
  },

  methods: {
    resetData() {
      this.rprList = [{ account: '', total: '', visible: false }];
      this.emitEvent(false);
    },

    // 控制快捷选项显示状态
    handleQuickShow(index, visible) {
      this.$set(this.rprList, index, {
        ...this.rprList[index],
        visible
      });
    },
    // 回调事件
    emitEvent(showToast = true) {
      this.$emit('refresh-total');
      this.$emit('check-error', showToast);
    },
    handleAccountChange(index) {
      const item = this.rprList[index];
      let finalVal = item.account;
      const maxAmount = this.maxAmount;
      // 是否超出最大值
      if (finalVal > maxAmount) {
        finalVal = maxAmount;
        this.$iaMessage.default(
          this.t('plvIA.redpacket.toast1', { t: maxAmount })
        );
      }
      // 是否含有小数点
      if (finalVal % 1 !== 0) {
        finalVal = Number(finalVal.toFixed(2));
      }

      this.$nextTick(() => {
        this.$set(this.rprList, index, {
          ...item,
          account: finalVal
        });
        this.emitEvent();
      });
    },
    handleTotalChange(index) {
      const item = this.rprList[index];
      let finalVal = item.total;
      const maxCount = this.maxCount;
      // 是否超出最大值
      if (finalVal > maxCount) {
        finalVal = maxCount;
        this.$iaMessage.default(
          this.t('plvIA.redpacket.toast2', { t: maxCount })
        );
      }

      this.$nextTick(() => {
        this.$set(this.rprList, index, {
          ...item,
          total: finalVal
        });
        this.emitEvent();
      });
    },
    // 设置快捷金额
    setQuickMoney(val, index) {
      this.$set(this.rprList, index, {
        ...this.rprList[index],
        account: val,
        visible: false
      });
      this.emitEvent();
    },
    // 添加一个选项
    addItems() {
      if (this.rprList.length >= 3) {
        return;
      }
      this.rprList.push({
        account: '',
        total: '',
        visible: false
      });
      this.emitEvent();
    },
    // 减少一个选项
    delItems(index) {
      if (this.rprList.length <= 1) {
        return;
      }
      this.rprList.splice(index, 1);
      this.emitEvent();
    }
  }
};
</script>

<style lang="scss">
.plv-ia-rpr-send-zoom-in-bottom-enter-active,
.plv-ia-rpr-send-zoom-in-bottom-leave-active {
  opacity: 1;
  transform: scaleY(1);
  transform-origin: center top;
  transition: transform 300ms cubic-bezier(0.23, 1, 0.32, 1),
    opacity 300ms cubic-bezier(0.23, 1, 0.32, 1);
}
.plv-ia-rpr-send-zoom-in-bottom-enter,
.plv-ia-rpr-send-zoom-in-bottom-leave-active {
  opacity: 0;
  transform: scaleY(0);
}

.plv-ia-rpr-send__content--send-equal {
  //padding: 0 70px 0 0;
  display: inline-flex;
  flex-direction: column;
  margin-top: 18px;

  &__item {
    display: flex;
    position: relative;
    // margin-top: 18px;
    .plv-ia-rpr-cell {
      margin-top: 0;
    }
  }
  &__item + &__item {
    margin-top: 18px;
  }

  &__account {
    .plv-ia-rpr-cell__right {
      width: 135px;
    }
  }

  &__total {
    .plv-ia-rpr-cell__left {
      width: 87px;
    }
    .plv-ia-rpr-cell__right {
      width: 89px;
    }
  }

  &__quick {
    position: absolute;
    top: 100%;
    width: 100%;
    background: #fff;
    box-sizing: border-box;
    border: 1px solid #cfd8dc;
    border-radius: 2px;
    z-index: 20;
    &__item {
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      color: #333;
      padding-left: 8px;
      cursor: pointer;
    }
  }

  &__btns {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -80px;
    width: 70px;
    &__item {
      width: 16px;
      height: 16px;
      margin-right: 8px;
      cursor: pointer;
    }
  }
}
</style>
